export const RAIL_EUROPE_TRAIN_CATEGORY_TYPE = {
  // 구간권
  TICKET: 'ticket',
  // 패스
  PASS: 'pass',
} as const;

export const JOURNEY_TYPE = {
  // 편도
  ONE_WAY: 'ONE_WAY',
  // 왕복
  ROUND_TRIP: 'ROUND_TRIP',
} as const;

export const ROUND_TRIP_JOURNEY_TYPE = {
  OUTBOUND: 'OUTBOUND',
  INBOUND: 'INBOUND',
} as const;

export const ROUND_TRIP_JOURNEY_TYPE_LABELS = {
  [ROUND_TRIP_JOURNEY_TYPE.OUTBOUND]: '가는편',
  [ROUND_TRIP_JOURNEY_TYPE.INBOUND]: '오는편',
} as const;

export const TRAIN_PLACE_TYPE = {
  STATION: 'STATION',
  CITY: 'CITY',
} as const;

export const RAIL_EUROPE_TAB_HEIGHT = 52;

export const RAIL_EUROPE_SEARCH_CONDITION_TYPE = {
  ORIGIN: 'origin',
  DESTINATION: 'destination',
  DATE: 'date',
  AGES: 'ages',
} as const;

export const AGE_NOTIFICATION_MESSAGES = [
  '만 4세 미만의 어린이는 성인과 좌석을 공유할 경우, 무료입니다.',
  '만 5~15세 아동은 요금 50% 할인 적용됩니다.',
];

export const MAX_AGE = 100;

export const AGE_LIST = Array.from({ length: MAX_AGE }, (_, i) => i);

export const MAX_REGISTERABLE_TRAVELERS = 9;

export const DEFAULT_TRAVELER_AGE = 25;

export const SORT_RADIO_GROUP_ITEM_LABELS = {
  DEPARTURE: '출발 빠른순',
  PRICE: '가격 낮은순',
  DURATION: '소요시간 짧은순',
} as const;

export const SORT_RADIO_GROUP_ITEM_VALUES = {
  DEPARTURE: 'DEPARTURE',
  PRICE: 'PRICE',
  DURATION: 'DURATION',
} as const;

export const SORT_RADIO_GROUP_ITEMS: {
  label: (typeof SORT_RADIO_GROUP_ITEM_LABELS)[keyof typeof SORT_RADIO_GROUP_ITEM_LABELS];
  value: (typeof SORT_RADIO_GROUP_ITEM_VALUES)[keyof typeof SORT_RADIO_GROUP_ITEM_VALUES];
}[] = [
  {
    label: SORT_RADIO_GROUP_ITEM_LABELS.DEPARTURE,
    value: SORT_RADIO_GROUP_ITEM_VALUES.DEPARTURE,
  },
  {
    label: SORT_RADIO_GROUP_ITEM_LABELS.PRICE,
    value: SORT_RADIO_GROUP_ITEM_VALUES.PRICE,
  },
  {
    label: SORT_RADIO_GROUP_ITEM_LABELS.DURATION,
    value: SORT_RADIO_GROUP_ITEM_VALUES.DURATION,
  },
];

export const RESULT_FILTER_TYPES = {
  DIRECT_TRAIN: 'DIRECT_TRAIN',
  DEPART_PLACE: 'DEPART_PLACE',
  ARRIVAL_PLACE: 'ARRIVAL_PLACE',
  DEPART_TIME: 'DEPART_TIME',
  OPERATOR: 'OPERATOR',
} as const;

export const RESULT_FILTER_TYPE_LABELS: Record<
  (typeof RESULT_FILTER_TYPES)[keyof typeof RESULT_FILTER_TYPES],
  string
> = {
  [RESULT_FILTER_TYPES.DIRECT_TRAIN]: '경유',
  [RESULT_FILTER_TYPES.DEPART_PLACE]: '출발지',
  [RESULT_FILTER_TYPES.ARRIVAL_PLACE]: '도착지',
  [RESULT_FILTER_TYPES.DEPART_TIME]: '출발 시간',
  [RESULT_FILTER_TYPES.OPERATOR]: '열차 운영업체',
};

export const ONLY_DIRECT_TRAIN_LABEL = '직행만';

export const DEFAULT_DEPART_TIME_FILTER: [number, number] = [0, 24];

export const OFFER_OPTION_CATEGORY = {
  STANDARD: 'standardOfferOptions',
  COMFORT: 'comfortOfferOptions',
  PREMIER: 'premierOfferOptions',
} as const;

export const OFFER_OPTION_CATEGORY_LABELS = {
  STANDARD: 'Standard',
  COMFORT: 'Comfort',
  PREMIER: 'Premier',
} as const;

export const FLEXIBILITY_TYPE = {
  NON_FLEX: 'NON_FLEX',
  SEMI_FLEX: 'SEMI_FLEX',
  FULL_FLEX: 'FULL_FLEX',
} as const;

export const TICKET_POLICY_TYPE = {
  YES: 'YES',
  NO: 'NO',
  WITH_CONDITION: 'WITH_CONDITION',
} as const;

export const TRAIN_SERVICE_TYPE = {
  AIRCON: 'AIRCON',
  AUDIO: 'AUDIO',
  BAGGAGE: 'BAGGAGE',
  BAR: 'BAR',
  BICYCLE: 'BICYCLE',
  BICYCLE_AVAILABLE: 'BICYCLE_AVAILABLE',
  BUFFET: 'BUFFET',
  DINING: 'DINING',
  HOT_FOOD: 'HOT_FOOD',
  HOT_DRINKS: 'HOT_DRINKS',
  INTERNET: 'INTERNET',
  INTERNET_AVAILABLE: 'INTERNET_AVAILABLE',
  LOUNGE: 'LOUNGE',
  LOUNGE_ACCESS: 'LOUNGE_ACCESS',
  MEAL: 'MEAL',
  NETWORK: 'NETWORK',
  NEWSPAPER: 'NEWSPAPER',
  ONLINE_FOOD: 'ONLINE_FOOD',
  PARKING: 'PARKING',
  POWER_SOCKET: 'POWER_SOCKET',
  PRIORITY_BOARDING: 'PRIORITY_BOARDING',
  PRIVATE: 'PRIVATE',
  QUIET: 'QUIET',
  RESTAURANT: 'RESTAURANT',
  RESTAURANT_1ST: 'RESTAURANT_1ST',
  SNACK: 'SNACK',
  STEWARD: 'STEWARD',
  TAXI: 'TAXI',
  TOUCH_SCREEN: 'TOUCH_SCREEN',
  TOILET: 'TOILET',
  TROLLEY: 'TROLLEY',
  USB_PLUG: 'USB_PLUG',
  VALET_PARKING: 'VALET_PARKING',
  VENDING_MACHINE: 'VENDING_MACHINE',
  VIDEO: 'VIDEO',
  WATER: 'WATER',
  WHEELCHAIR: 'WHEELCHAIR',
  WHEELCHAIR_RES: 'WHEELCHAIR_RES',
  /** eurostar 전용 서비스 */
  LUGGAGE_ALLOWANCE: 'LUGGAGE_ALLOWANCE',
  /** eurostar 전용 서비스 */
  EXTRA_SPACIOUS_SEATS: 'EXTRA_SPACIOUS_SEATS',
  COUCHETTE: 'COUCHETTE',
  STROLLER_SPACE: 'STROLLER_SPACE',
  LADIES_COMPARTMENT: 'LADIES_COMPARTMENT',
  FAMILY_COMPARTMENT: 'FAMILY_COMPARTMENT',
  CHILDREN_COMPARTMENT: 'CHILDREN_COMPARTMENT',
} as const;

export const TRAIN_SERVICE_ICON_MAP = {
  [TRAIN_SERVICE_TYPE.AIRCON]: 'IcoAirConditioner',
  [TRAIN_SERVICE_TYPE.AUDIO]: 'IcoAudio',
  [TRAIN_SERVICE_TYPE.BAGGAGE]: 'IcoLuggage',
  [TRAIN_SERVICE_TYPE.BAR]: 'IcoLocalBar',
  [TRAIN_SERVICE_TYPE.BICYCLE_AVAILABLE]: 'IcoBicycleAvailable',
  [TRAIN_SERVICE_TYPE.BICYCLE]: 'IcoBicycle',
  [TRAIN_SERVICE_TYPE.BUFFET]: 'IcoBuffet',
  [TRAIN_SERVICE_TYPE.DINING]: 'IcoDining',
  [TRAIN_SERVICE_TYPE.HOT_DRINKS]: 'IcoHotDrinks',
  [TRAIN_SERVICE_TYPE.HOT_FOOD]: 'IcoHotFood',
  [TRAIN_SERVICE_TYPE.INTERNET_AVAILABLE]: 'IcoInternetAvailable',
  [TRAIN_SERVICE_TYPE.INTERNET]: 'IcoWifi',
  [TRAIN_SERVICE_TYPE.LOUNGE_ACCESS]: 'IcoLoungeAccess',
  [TRAIN_SERVICE_TYPE.LOUNGE]: 'IcoLounge',
  [TRAIN_SERVICE_TYPE.MEAL]: 'IcoRamenDining',
  [TRAIN_SERVICE_TYPE.NEWSPAPER]: 'IcoNewspaper',
  [TRAIN_SERVICE_TYPE.ONLINE_FOOD]: 'IcoOnlineFood',
  [TRAIN_SERVICE_TYPE.PARKING]: 'IcoParking',
  [TRAIN_SERVICE_TYPE.POWER_SOCKET]: 'IcoPowerSocket',
  [TRAIN_SERVICE_TYPE.PRIORITY_BOARDING]: 'IcoPriorityBoarding',
  [TRAIN_SERVICE_TYPE.PRIVATE]: 'IcoPrivate',
  [TRAIN_SERVICE_TYPE.QUIET]: 'IcoVolumeOff',
  [TRAIN_SERVICE_TYPE.RESTAURANT_1ST]: 'IcoRestaurant1St',
  [TRAIN_SERVICE_TYPE.RESTAURANT]: 'IcoRestaurant',
  [TRAIN_SERVICE_TYPE.SNACK]: 'IcoSnack',
  [TRAIN_SERVICE_TYPE.STEWARD]: 'IcoSteward',
  [TRAIN_SERVICE_TYPE.TAXI]: 'IcoTaxi',
  [TRAIN_SERVICE_TYPE.TOILET]: 'IcoToilet',
  [TRAIN_SERVICE_TYPE.TOUCH_SCREEN]: 'IcoTouchScreen',
  [TRAIN_SERVICE_TYPE.TROLLEY]: 'IcoShoppingCart',
  [TRAIN_SERVICE_TYPE.USB_PLUG]: 'IcoUsbPlug',
  [TRAIN_SERVICE_TYPE.VALET_PARKING]: 'IcoValetParking',
  [TRAIN_SERVICE_TYPE.VENDING_MACHINE]: 'IcoVendingMachine',
  [TRAIN_SERVICE_TYPE.VIDEO]: 'IcoPlayCircle',
  [TRAIN_SERVICE_TYPE.WATER]: 'IcoWater',
  [TRAIN_SERVICE_TYPE.WHEELCHAIR_RES]: 'IcoAccessible',
  [TRAIN_SERVICE_TYPE.WHEELCHAIR]: 'IcoWheelchair',
  [TRAIN_SERVICE_TYPE.LUGGAGE_ALLOWANCE]: 'IcoLuggageAlt',
  [TRAIN_SERVICE_TYPE.EXTRA_SPACIOUS_SEATS]: 'IcoSpaciousSeat',
  [TRAIN_SERVICE_TYPE.COUCHETTE]: 'IcoHotel',
  [TRAIN_SERVICE_TYPE.STROLLER_SPACE]: 'IcoChildFriendly',
  [TRAIN_SERVICE_TYPE.LADIES_COMPARTMENT]: 'IcoFemale',
  [TRAIN_SERVICE_TYPE.FAMILY_COMPARTMENT]: 'IcoFamily',
  [TRAIN_SERVICE_TYPE.CHILDREN_COMPARTMENT]: 'IcoKid',
};

export const RAIL_EUROPE_SEARCH_STALE_TIME = 5 * 60 * 1000;

export const TRAVELER_FILED_TYPE = {
  birthDate: 'birthDate',
  drivingLicenseType: 'drivingLicenseType',
  email: 'email',
  engFirstName: 'engFirstName',
  engLastName: 'engLastName',
  gender: 'gender',
  id: 'id',
  korName: 'korName',
  passportExpireDate: 'passportExpireDate',
  passportNationality: 'passportNationality',
  passportNumber: 'passportNumber',
  phoneIcc: 'phoneIcc',
  phoneNumber: 'phoneNumber',
  userId: 'userId',
  countryOfResidence: 'countryOfResidence',
} as const;

export const DIRECTION = {
  ORIGIN: 'origin',
  DESTINATION: 'destination',
} as const;

export const TRAIN_PLACE_SPLIT_SYMBOL = ',';

export const DEFAULT_DEPARTURE_TIME = '06:00';
export const DEPARTURE_TIME_LIST = Array.from({ length: 24 }, (_, i) => {
  const hour = i.toString().padStart(2, '0');
  return `${hour}:00`;
});
